<template>
    
    <div class="game">

        <transition name="start">
            <section class="g-start" v-if="!gameStarted">
                <div class="g-wrapper">
                    <div class="g-start-content">
                        <header class="g-start-header">
                            <picture>
                                <img src="images/dewalt-logo.png" alt="">
                            </picture>
                            <picture>
                                <img src="images/tn-logo.png" alt="">
                            </picture>
                        </header>

                        <div class="g-start-text">
                            <div class="g-start-title">
                                Насколько хорошо вы ориентируетесь в строительных инструментах?<br> Проверьте знания!
                            </div>
                            <div class="g-start-description">
                                <p>Правильно выбранные материалы — половина успеха при возведении кровли. Но чтобы сделать всё качественно, важно выбрать ещё<br> и подходящие инструменты.</p>
                                <p>Проверьте, насколько хорошо вы готовы к монтажу кровли.</p>
                            </div>
                        </div>

                        <div class="g-start-action">
                            <button type="button" class="g-start-button" @click="gameStarted = !gameStarted">
                                Начать игру
                                <svg width="33" height="32">
                                    <use xlink:href="images/sprite.svg#arrow"></use>
                                </svg>
                            </button>
                            <div class="g-start-placeholder">
                                Игра
                            </div>
                        </div>
                    </div>
                    <div class="g-start-picture">
                        <picture>
                            <source srcset="images/tool-small.png" media="(max-width: 900px)">
                            <img src="images/tool.png" alt="">
                        </picture>
                    </div>
                </div>
            </section> <!-- g-start -->
        </transition>

        <transition name="game">
            <section class="g-main" v-if="gameStarted">

                <div class="g-wrapper">

                    <div class="g-process" v-if="!showResult">

                        <div class="g-area">

                            <div class="g-area-content">
                                <div class="g-ttl" v-html="question.title"></div>

                                <div class="g-area-wrapper">
                                    <div class="g-steps">
                                        <ul>
                                            <li v-for="item,key in gameData" :class="stepClass(key)">
                                                {{ key }}
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="g-area-description" :class="{ '-time-for-hide': checkStage }" v-html="question.description"></div>

                                    <!--picture class="g-area-picture">
                                        <img :src="getImage" alt="">
                                    </picture-->

                                    <div class="g-area-images" :class="imageClass">
                                        <img src="images/roof-1.svg" alt="">
                                        <img src="images/roof-9.svg" alt="">
                                        <img src="images/roof-3.svg" alt="">
                                        <img src="images/roof-4.svg" alt="">
                                    </div>
                                </div>
                            </div>

                            <div class="g-bottom">
                                <div class="g-answers-wrapper">
                                    <div class="g-answers">
                                        <div class="g-answers-col" v-for="item,key in question.questions" :class="answerClasses(key)">
                                            <button type="button" class="g-answers-item" @click="select(key)">

                                                <span class="g-answers-title" v-html="item.title">
                                                </span>
                                                <picture class="g-answers-picture">
                                                    <img :src="item.picture" alt="">
                                                </picture>
                                                <svg class="g-answers-bg">
                                                    <use xlink:href="images/sprite.svg#answer"></use>
                                                </svg>

                                                <svg v-if="checkStage && item.correct" class="g-answers-icon" width="32" height="32">
                                                    <use xlink:href="images/sprite.svg#success"></use>
                                                </svg>
                                                <svg v-else-if="item.select && checkStage" class="g-answers-icon" width="32" height="32">
                                                    <use xlink:href="images/sprite.svg#error"></use>
                                                </svg>
                                                <svg v-else-if="item.select" class="g-answers-icon" width="32" height="32">
                                                    <use xlink:href="images/sprite.svg#selected"></use>
                                                </svg>

                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <transition name="msg">
                                    <div class="g-msg" v-if="checkStage">
                                        <div class="g-msg-item g-error" v-if="errorText">
                                            <span>{{ errorText }}</span>
                                        </div>
                                        <div class="g-msg-item">
                                            <span>{{ successText }}</span>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>

                        <footer class="g-footer">
                            <button class="g-button g-check" :disabled="buttonState" type="button" @click="check()" :id="buttonID">
                                {{ buttonText }}
                                <svg width="16" height="17">
                                    <use xlink:href="images/sprite.svg#arrow"></use>
                                </svg>
                            </button>

                            <div class="g-description" v-if="checkStage">
                                <div class="g-description-item" v-if="errorText">
                                    <svg width="18" height="12">
                                        <use xlink:href="images/sprite.svg#quote"></use>
                                    </svg>
                                    <span>{{ errorText }}</span>
                                </div>
                                <div class="g-description-item">
                                    <svg width="18" height="12">
                                        <use xlink:href="images/sprite.svg#quote"></use>
                                    </svg>
                                    <span>{{ successText }}</span>
                                </div>
                            </div>

                            <div class="g-start-header">
                                <picture>
                                    <img src="images/dewalt-logo.png" alt="">
                                </picture>
                                <picture>
                                    <img src="images/tn-logo.png" alt="">
                                </picture>
                            </div>
                        </footer>

                    </div>

                    <transition name="start">
                        <div class="g-result" v-if="showResult">
                            <div class="g-start-content">
                                <header class="g-start-header">
                                    <picture>
                                        <source srcset="images/dewalt-logo.png" media="(orientation: portrait) and (max-width: 1200px)">
                                        <source srcset="images/dewalt-logo.png" media="(orientation: portrait) and (max-width: 500px)">
                                        <img src="images/dewalt-black-logo.png" alt="">
                                    </picture>
                                    <picture>
                                        <img src="images/tn-logo.png" alt="">
                                    </picture>
                                </header>

                                <div class="g-start-text">
                                    <div class="g-result-score">
                                      {{ successQuestions }}<span>/</span>{{ totalQuestions }}
                                    </div>
                                    <div class="g-result-content">
                                        <div class="g-result-description">
                                            ваш результат:
                                        </div>
                                        <div class="g-result-about" v-html="resultText[successQuestions]"></div>
                                    </div>
                                </div>

                                <picture class="g-result-picture">
                                    <img src="images/picture-5.svg" alt="">
                                </picture>

                                <div class="g-start-action">
                                    <button type="button" class="g-start-button" @click="restart()">
                                        Попробовать снова
                                        <svg width="33" height="32">
                                            <use xlink:href="images/sprite.svg#arrow"></use>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </transition>

                </div>

            </section>
        </transition>

    </div>

</template>

<script>

const gameData = {
    1: {
        'title': 'Демонтируем <span>старую кровлю</span>',
        'description': `<p>Если стропильная система сгнила или изначально была установлена неправильно, то её нужно будет демонтировать перед началом возведения новой кровли.</p>
                    <p>Выберите инструмент для максимально быстрого и безопасного монтажа.</p>`,
        'image_start': 'images/roof-1.png',
        'image_end': 'images/roof-2.png',
        'questions': {
            0: {
                'title': 'Вариант А',
                'picture': 'images/tool-1.png',
                'description': 'Это не пила, а ножовка по металлу. Конечно, ей можно попытаться распилить стропила, но вы быстро откажетесь от этой идеи.'
            },
            1: {
                'title': 'Вариант Б',
                'picture': 'images/tool-2.png',
                'description': 'Нет. С циркулярной пилой лучше не лезть на крышу — это просто опасно.'
            },
            2: {
                'title': 'Вариант В',
                'picture': 'images/tool-3.png',
                'description': 'Хороший вариант, если надо распилить дерево или выглядеть, как персонаж фильма ужасов, но не для демонтажа.'
            },
            3: {
                'title': 'Вариант Г',
                'picture': 'images/tool-4.png',
                'correct': true,
                'description': 'Отличный выбор! Это сабельная пила — оптимальный вариант для демонтажа стропил.'
            },
        }
    },
    2: {
        'title': 'Собираем <span>стропильную систему</span>',
        'description': `<p>После демонтажа старой стропильной системы настал момент собрать новую. А значит, нужно как-то соединить стропила, обрешётку и сплошной настил.</p>
                    <p>Как будем это делать?</p>`,
        'image_start': 'images/roof-2.png',
        'image_end': 'images/roof-3.svg',
        'questions': {
            0: {
                'title': 'Вариант А',
                'picture': 'images/tool-5.png',
                'description': 'С отвёрткой вы растянете работу на много дней и не сможете закрутить шурупы с одинаковой силой. Зато руки накачаете.'
            },
            1: {
                'title': 'Вариант Б',
                'picture': 'images/tool-6.png',
                'correct': true,
                'description': 'Верно! Обычно стропила соединяют шурупами, поэтому нам понадобится шуруповёрт.'
            },
            2: {
                'title': 'Вариант В',
                'picture': 'images/tool-7.png',
                'description': 'Это безударная дрель — полезный инструмент, но не для этой задачи.'
            },
            3: {
                'title': 'Вариант Г',
                'picture': 'images/tool-8.png',
                'description': 'Нет, это фрезер по гипсокартону. Тут нам он не нужен.'
            },
        }
    },
    3: {
        'title': 'Укладываем <span>подкладочный ковёр</span>',
        'description': `<p>Чтобы добиться качественной гидроизоляции кровли, перед монтажом битумной черепицы нужно постелить подкладочный ковер.</p>
                    <p>Какой инструмент будем использовать, чтобы ковер приклеился к основанию плотно и ровно, если на улице ниже +10 °С?</p>`,
        'image_start': 'images/picture-3.png',
        'image_end': 'images/picture-4.png',
        'questions': {
            0: {
                'title': 'Вариант А',
                'picture': 'images/tool-9.png',
                'description': 'Нет, это промышленный пылесос — инструмент полезный, но не при укладке подкладочного ковра.'
            },
            1: {
                'title': 'Вариант Б',
                'picture': 'images/tool-10.png',
                'description': 'Мимо. Это перфоратор, а нам не нужно сверлить подкладочный ковёр. Он крепится при помощи самоклеящегося слоя и кровельных гвоздей.'
            },
            2: {
                'title': 'Вариант В',
                'picture': 'images/tool-11.png',
                'correct': true,
                'description': 'Бинго! Это пистолет горячего воздуха. Он нужен, чтобы прогреть самоклеящийся слой подкладочного ковра. Но важно помнить, что дополнительный прогрев рекомендуется использовать при температуре 0 °С до +10 °С'
            },
            3: {
                'title': 'Вариант Г',
                'picture': 'images/tool-12.png',
                'description': 'Это лобзик, а пилить подкладочный ковёр нам не нужно.'
            },
        }
    },
    4: {
        'title': 'Монтируем <span>гибкую черепицу</span>',
        'description': `<p>Чтобы зафиксировать гибкую черепицу на кровле, вам понадобятся гвозди, но не обычные, а кровельные.</p>
                    <p>Какой инструмент нам понадобится, чтобы закрепить черепицу гвоздями?</p>`,
        'image_start': 'images/picture-4.png',
        'image_end': 'images/picture-5.png',
        'questions': {
            0: {
                'title': 'Вариант А',
                'picture': 'images/tool-17.png',
                'correct': true,
                'description': 'Верно! Молоток — это вечная классика.'
            },
            1: {
                'title': 'Вариант Б',
                'picture': 'images/tool-18.png',
                'description': 'Формально это молоток… Но вот только отбойный, а долбить бетон нам не надо.'
            },
            2: {
                'title': 'Вариант В',
                'picture': 'images/tool-15.png',
                'description': 'Формально это молоток… Но вот только отбойный, а долбить бетон нам не надо.'
            },
            3: {
                'title': 'Вариант Г',
                'picture': 'images/tool-16.png',
                'description': 'Мимо. Это угловая дрель, поэтому у неё такая необычная форма.'
            },
        }
    }
};

export default {
    components: {
    },
    data: () => ({
        checkStage: false,
        showResult: false,
        gameStarted: false,
        gamePosition: 1,
        gameStage: {},
        gameData: JSON.parse(JSON.stringify(gameData)),
        showPromoCode: false,
        promoCode: '',
        resultText: {
            0: 'Попробуем ещё раз, чтобы ничего не перепутать во время строительства.',
            1: 'Вы точно когда-то пользовались молотком и отвёрткой.',
            2: 'Неплохо! Пистолетом горячего воздуха вас точно не удивить ;)',
            3: 'Ещё немного, и вы станете настоящим экспертом по строительным инструментам!',
            4: 'Поздравляем! Вы правильно ответили на все 4 вопроса.'
        }
    }),
    computed: {
        // вернет текущий вопрос
        question(){
            return this.gameData[this.gamePosition];
        },
        // Надпись на кнопке
        buttonID(){
            let prefix =  this.checkStage ? 'verified': 'check';
            return prefix + '_' + this.gamePosition;
        },
        buttonText(){
            return this.checkStage ? 'Далее': 'Проверить';
        },
        // Состояние кнопки
        buttonState(){
            return this.gameData[this.gamePosition].selected ? false : 'disabled';
        },
        // общее количество вопросов
        totalQuestions(){
            return Object.keys(this.gameData).length;
        },
        // Получение изображения
        getImage(){
            let currentItem = this.gameData[this.gamePosition];
            return this.checkStage ? currentItem.image_end : currentItem.image_start;
        },
        // Получение комментария о правильном ответе
        successText(){
            let currentQuestion = this.gameData[this.gamePosition].questions,
                successText = '';

            Object.keys(currentQuestion).some( (item) => {
                if(currentQuestion[item].correct === true)
                    successText = currentQuestion[item].description;
            });

            return successText;
        },
        // Получение комментария для ошибочного ответа
        errorText(){
            if(this.gameData[this.gamePosition].success === false) {
                let currentQuestion = this.gameData[this.gamePosition].questions,
                errorText = '';
                Object.keys(currentQuestion).some( (item) => {
                    if(currentQuestion[item].select === true)
                        errorText = currentQuestion[item].description;
                });
                return errorText;
            }
            else return false;
        },
        successQuestions(){
            let count = 0;
            Object.keys(this.gameData).some( (item) => {
                if(this.gameData[item].success === true)
                    count++;
            });

            if(this.totalQuestions === count) {
                this.showPromoCode = true;
                this.gepPromoCode(); // Получим промокод
            }

            return count;
        },
        imageClass() {
            if(this.checkStage == false) return 'step-'+this.gamePosition;
            else return 'animated step-'+this.gamePosition;
        }
    },
    methods: {
        // Клик по варианту ответа
        select(key) {
            if(!this.checkStage) {

                for (let k of Object.keys(this.gameData[this.gamePosition].questions)) {
                    let element = this.gameData[this.gamePosition].questions[k];

                    if(element.select === true && key !== k) {
                        element.select = false;
                    }
                    else if(key === k) {
                        element.select = true;
                        this.gameData[this.gamePosition].selected = true;

                        if(element.correct === true) {
                            this.gameData[this.gamePosition].success = true;
                        }
                        else this.gameData[this.gamePosition].success = false;
                    }
                }
            }
        },
        // Расстановка класса у варианта ответа
        answerClasses(key){
            let answer = this.gameData[this.gamePosition].questions[key],
                className = '';

            if(this.checkStage === true && answer.correct === true) {
                className = 'g-success';
            }
            else if(this.checkStage === true && answer.select === true) {
                className = 'g-error';
            }
            else if(answer.select === true) className = 'g-checked';

            return className;
        },
        stepClass(key) {
            let step = this.gameData[key],
                className = '';

            if(key == this.gamePosition && this.checkStage === false) {
                className = 'g-active';
            }
            else if(step.success === true) {
                className = 'g-success';
            }
            else if(step.success === false) {
                className = 'g-error';
            }

            return className;
        },
        // Проверка правильности
        check() {
            if(this.checkStage === false) {
                this.checkStage = true;
            }
            else {
                this.checkStage = false;

                if(this.totalQuestions > this.gamePosition)
                    this.gamePosition = this.gamePosition + 1;
                else this.showResult = true;
            }
        },
        gepPromoCode() {
            let that = this;
            if(this.showPromoCode === true) {
                fetch('/journal/game-makita/promo_codes/', {
                    method: 'POST',
                    mode: "same-origin",
                    credentials: "same-origin",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                    body: '',
                }).then(response => response.json())
                    .then((response) => {
                        that.promoCode = response.code;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        restart() {
            this.checkStage = false;
            this.showResult = false;
            this.gameStarted = true;
            this.gamePosition = 1;
            this.gameStage = {};
            this.gameData = JSON.parse(JSON.stringify(gameData));
        }
    }
}

</script>